export const MAX_RESUME_BYTES = 1024 * 1024;
const ACCEPTED_EXTENSIONS = [".pdf", ".docx"];

export function validateResumeFile(file) {
  if (!ACCEPTED_EXTENSIONS.some((extension) => file.name.toLowerCase().endsWith(extension))) {
    return "Please upload a PDF or DOCX file.";
  }
  if (file.size > MAX_RESUME_BYTES) return "File must be 1 MB or smaller.";
  return null;
}

export function buildResumeFormData({ file, source, name, email, phone, jd }) {
  const data = new FormData();
  data.append("file", file);
  data.append("consent", "true");
  data.append("source", source);
  if (name) data.append("name", name);
  if (email) data.append("email", email);
  if (phone) data.append("phone", phone);
  if (jd.trim()) data.append("job_description", jd.trim());
  return data;
}